import { isFeatureEnabled } from 'owa-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function isNewsEnabled(): boolean {
    const userConfig = getUserConfiguration();
    return (
        isFeatureEnabled('tri-newsDev') ||
        ((isFeatureEnabled('tri-news') || isFeatureEnabled('tri-newsCompact')) &&
            !userConfig.SessionSettings.IsPremiumConsumerMailbox &&
            !userConfig.IsConsumerChild)
    );
}
